import React, { useCallback, useState } from "react"
import PropTypes from "prop-types"
import { parseISO, formatDistanceToNow, format } from "date-fns"

import { Formats } from "./formats"
import { useTopicUpdater } from "./updater"

const Topic = props => {
  Topic.propTypes = {
    path: PropTypes.string.isRequired,
    format: PropTypes.string.isRequired,
    type: PropTypes.string
  }

  const [data, setData] = useState(props)
  const Format = Formats[data.format]
  const handleUpdate = useCallback(nextData => {
    setData(nextData)
  }, [])

  useTopicUpdater({
    path: data.path,
    status: data.status,
    onUpdate: handleUpdate
  })

  if (Format == undefined) {
    throw `Format Error. Couldn't find the following format: ${
      props.type
    }. Following types are accepted:\n ${Object.keys(Formats).join("\n ")}`
  }

  const updatedAt = data.updated_at ? parseISO(data.updated_at) : null
  const updatedAtDescription = updatedAt ? formatDistanceToNow(updatedAt) : null
  const updatedAtFormatted = updatedAt
    ? format(updatedAt, "MMM d, h:mm a")
    : null

  return (
    <Format
      {...data}
      updatedAtDescription={updatedAtDescription}
      updatedAtFormatted={updatedAtFormatted}
    />
  )
}

export { Topic }
